import { AnimatePresence } from 'motion/react'
import React from 'react'

interface MotionModalRootProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  children: React.ReactNode
}

export default function MotionModalRoot({
  open,
  onOpenChange,
  children,
}: MotionModalRootProps): JSX.Element {
  React.useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && open) {
        onOpenChange(false)
      }
    }

    if (open) {
      document.addEventListener('keydown', handleEscape)
      document.body.style.overflow = 'hidden'
    }

    return () => {
      document.removeEventListener('keydown', handleEscape)
      document.body.style.overflow = 'unset'
    }
  }, [open, onOpenChange])

  return <AnimatePresence>{open && <>{children}</>}</AnimatePresence>
}
